import { Theme } from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

import CloseWindow from '@/assets/icons/close-button.svg?react';
import { useTranslator } from '@/hooks/useTranslator';

interface Props {
  readonly title: string;
  readonly contentSx?: SystemStyleObject<Theme>;

  onClose(): void;
}

export const Header: React.FC<Props> = (props: Props): React.ReactElement => {
  const { title, onClose, contentSx } = props;

  const tr = useTranslator();

  return (
    <Box sx={styles.container}>
      <Box sx={contentSx ? [styles.content, contentSx] : styles.content}>
        <Typography fontSize={24} lineHeight="32px" fontWeight={500}>
          {tr(title)}
        </Typography>
        <Box sx={styles.button}>
          <IconButton color="inherit" onClick={onClose}>
            <CloseWindow fill="currentColor" />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

const styles: Record<string, SystemStyleObject<Theme>> = {
  container: {
    position: 'sticky',
    top: 0,
    backgroundColor: 'custom.White',
    overflowAnchor: 'none',
    zIndex: 2,
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    mx: 'auto',
    px: 8,
    height: 96,
    width: 1024,
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'text.primary',
    top: 0,
    bottom: 0,
    width: 24,
    height: 24,
  },
};
